import { loadSession, authHeaders } from './gatewayAuth'

const HEARTBEAT_MS = 45000
const PLATFORM = 'pwa'

let timer = null
let started = false
let listenersBound = false

/**
 * @param {'connect'|'heartbeat'|'disconnect'} event
 * @param {{ keepalive?: boolean }} [opts]
 */
async function postPresence(event, opts) {
  const session = loadSession()
  if (!session || !session.token || !session.deviceId) return
  const url = `${session.serverUrl}/api/v1/presence`
  const body = JSON.stringify({
    device_id: session.deviceId,
    event,
    platform: PLATFORM,
  })
  const headers = {
    'Content-Type': 'application/json',
    ...authHeaders(session),
  }
  try {
    await fetch(url, {
      method: 'POST',
      headers,
      body,
      keepalive: !!(opts && opts.keepalive),
    })
  } catch (e) {
    /* ignore offline / network errors */
  }
}

function onVisibilityChange() {
  if (!started) return
  if (document.visibilityState === 'visible') {
    void postPresence('connect')
  }
  // when hidden: stop sending; server TTL → away/offline
}

function onPageHide() {
  if (!started) return
  void postPresence('disconnect', { keepalive: true })
}

function bindListeners() {
  if (listenersBound || typeof document === 'undefined') return
  listenersBound = true
  document.addEventListener('visibilitychange', onVisibilityChange)
  window.addEventListener('pagehide', onPageHide)
  window.addEventListener('beforeunload', onPageHide)
}

function unbindListeners() {
  if (!listenersBound || typeof document === 'undefined') return
  listenersBound = false
  document.removeEventListener('visibilitychange', onVisibilityChange)
  window.removeEventListener('pagehide', onPageHide)
  window.removeEventListener('beforeunload', onPageHide)
}

/**
 * Start presence after Gateway login / session restore.
 */
export function startPresence() {
  const session = loadSession()
  if (!session || !session.token) return
  bindListeners()
  started = true
  void postPresence('connect')
  if (timer) clearInterval(timer)
  timer = setInterval(() => {
    if (!started) return
    if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
      return
    }
    void postPresence('heartbeat')
  }, HEARTBEAT_MS)
}

/**
 * Stop presence on Gateway logout.
 */
export function stopPresence() {
  if (started) {
    void postPresence('disconnect', { keepalive: true })
  }
  started = false
  if (timer) {
    clearInterval(timer)
    timer = null
  }
  unbindListeners()
}

export function isPresenceStarted() {
  return started
}
